import { ConversationAPI } from 'api'

export const toggleBotBuilderBranchingGate = async (enable = false) => {
  return ConversationAPI.post(
    `/playbooks/toggle_bot_builder_branching_beta?enable=${enable}`
  )
}
